import { Link, useNavigate } from "react-router-dom";

import styles from "./fitness.module.css";

const FitnessTraining = () => {
  const navigate = useNavigate();

  return (
    <div className={`${styles["fitness-training"]} container sections-padding`}>
      <div className={styles["section-head"]}>
        <div>
          <p className="paragraph">Our Fitness Training</p>
          <h2>Upcoming Classes</h2>
        </div>
        <div>
          <button onClick={() => navigate("/classes")}>More Class</button>
        </div>
      </div>
      <div className={styles["boxes-container"]}>
      </div>
    </div>
  );
};

export default FitnessTraining;
